import instance from "./instance";
import mockData from "./mock.json";
import { mock } from "./index";
import { prepareParam } from "../helpers/utils";
import Cookies from "js-cookie";

const TOKEN_KEY = "waqtak_token";

export const lookups = {
  getDistrict: async (newApi) => {
    if (newApi) {
      if (mock) {
        return { status: 200, data: mockData.GetDISTRECT };
      }
      return instance.get("/Land/GetDistrictsNotQS");
    }
    switch (mock) {
      case true:
        return { status: 200, data: mockData.GetDISTRECT };
      default:
        return instance.get("/Lookup/GetDISTRECT");
    }
  },
  getDept: async (districtId, newApi) => {
    if (newApi) {
      if (mock) {
        return { status: 200, data: mockData.GetDEPT };
      }
      return instance.get(
        "/Land/GetDepartmentsNoQS?DISTRECT_CODE=" + districtId,
      );
    }
    switch (mock) {
      case true:
        return { status: 200, data: mockData.GetDEPT };
      default:
        return instance.get("/Lookup/GetDEPT?DistrectId=" + districtId);
    }
  },
  getVill: async (districtId, deptId, newApi) => {
    if (newApi) {
      if (mock) {
        return { status: 200, data: mockData.GetVILL };
      }
      return instance.get(
        `/Land/GetVillagesNotQS?DISTRECT_CODE=${districtId}&DEPT_CODE=${deptId}`,
      );
    }
    switch (mock) {
      case true:
        return { status: 200, data: mockData.GetVILL };
      default:
        return instance.get(
          `/Lookup/GetVILL?DistrectId=${districtId}&DeptId=${deptId}`,
        );
    }
  },
  getVillByDistrict: async (districtId) => {
    switch (mock) {
      case true:
        return { status: 200, data: mockData.GetVILL };
      default:
        return instance.get(`/Land/GetVillLkp?distrectCode=${districtId}`);
    }
  },
  getHod: async (villId, newApi) => {
    if (newApi) {
      if (mock) {
        return { status: 200, data: mockData.GetHOD };
      }
      return instance.get(`/Land/GetHodesNotQS?VILL_CODE=${villId}`);
    }
    switch (mock) {
      case true:
        return { status: 200, data: mockData.GetHOD };
      default:
        return instance.get(`/Lookup/GetHOD?VillId=${villId}`);
    }
  },
  getSect: async (villId, hodId, newApi) => {
    if (newApi) {
      if (mock) {
        return { status: 200, data: mockData.GetSECT };
      }
      return instance.get(
        `/Land/GetSectsNotQS?VILL_CODE=${villId}&HOD_CODE=${hodId}`,
      );
    }
    switch (mock) {
      case true:
        return { status: 200, data: mockData.GetSECT };
      default:
        return instance.get(`/Lookup/GetSECT?VillId=${villId}&hodId=${hodId}`);
    }
  },
  getParcel: async (villId, hodId, sectId, newApi) => {
    if (newApi) {
      if (mock) {
        return { status: 200, data: mockData.GetPARCEL };
      }
      return instance.get(
        `/Land/GetParcelsNotQS?VILL_CODE=${villId}&HOD_CODE=${hodId}&SECT_CODE=${sectId}`,
      );
    }
    switch (mock) {
      case true:
        return { status: 200, data: mockData.GetPARCEL };
      default:
        return instance.get(
          `/Lookup/GetPARCEL?VillId=${villId}&HodId=${hodId}&SectId=${sectId}`,
        );
    }
  },
  getScales: async () => {
    switch (mock) {
      case true:
        return { status: 200, data: mockData.GetScal };
      default:
        return instance.get("/Lookup/GetScal");
    }
  },
  getHodClearanceIssuer: async () => {
    switch (mock) {
      case true:
        return { status: 200, data: mockData.GetSecurityApprovalsIssuers };
      default:
        return instance.get("/Lookup/GetSecurityApprovalsIssuers");
    }
  },
  isRelatedToAnyAuthority: async (regNo) => {
    switch (mock) {
      case true:
        return { status: 200, data: false };
      default:
        return instance.get(
          `/Lookup/IsRelatedToAnyAuthority?RegNo=${prepareParam(regNo)}`,
        );
    }
  },
  belongsToWhichAuthority: async (pRandom, dontUpdateLoading = false) => {
    switch (mock) {
      case true:
        return { status: 200, data: false };
      default:
        return instance.get(
          `/Municipality/IsThePropertyBelongs?PRandom=${pRandom}`,
          {
            hideToaster: true,
            dontUpdateLoading: dontUpdateLoading,
          },
        );
    }
  },
  belongsToAsezaAuthority: async ({ reG_NO }) => {
    switch (mock) {
      case true:
        return { status: 200, data: true };
      default:
        return instance.get(
          `/Lookup/IsRelatedToAqaba?RegNo=${prepareParam(reG_NO)}`,
        );
    }
  },
  belongsToJvaAuthority: async ({ reG_NO }) => {
    switch (mock) {
      case true:
        return { status: 200, data: true };
      default:
        return instance.get(
          `/Lookup/IsRelatedToJordanValley?RegNo=${prepareParam(reG_NO)}`,
        );
    }
  },
  belongsToUrbanDevAuthority: async ({ reG_NO }) => {
    switch (mock) {
      case true:
        return { status: 200, data: true };
      default:
        return instance.get(
          `/Lookup/IsRelatedToUrbanDevelopmentCorporation?RegNo=${prepareParam(
            reG_NO,
          )}`,
        );
    }
  },
  belongsToPetraAuthority: async ({ reG_NO }) => {
    switch (mock) {
      case true:
        return { status: 200, data: true };
      default:
        return instance.get(
          `/Lookup/IsRelatedToPetra?RegNo=${prepareParam(reG_NO)}`,
        );
    }
  },
  getServiceCentersCount: async ({ districtCode, deptCode }) => {
    switch (mock) {
      case true:
        return {
          status: 200,
          data: [
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
            {
              currenT_COUNT: 1,
              maX_COUNT: 15,
            },
          ],
        };
      default:
        return instance.get(`/Appointments/GetServiceCentersCount`, {
          params: { deptCode, districtCode },
          hideToaster: true,
        });
    }
  },
  getWaqtakAutherization: async ({ refrenceNumber }) => {
    switch (mock) {
      case true:
        return "";
      default: {
        const storedToken = Cookies.get(TOKEN_KEY);

        if (storedToken) {
          return storedToken; // Return the existing token if it's still valid
        }
        const waqtakRes = await instance.get(
          `/Appointments/GetWaqtakAutherization`,
          { params: { refrenceNumber } },
        );
        const waqtakData = waqtakRes.data;

        if (waqtakData?.access_token) {
          // Calculate expiration time in days (expires_in is in seconds)
          const expiryDate = new Date();
          expiryDate.setSeconds(
            expiryDate.getSeconds() + Number(waqtakData.expires_in),
          );

          // Store token with expiration date
          Cookies.set(TOKEN_KEY, waqtakData.access_token, {
            expires: expiryDate,
          });

          return waqtakData.access_token;
        }
        return "";
      }
    }
  },
  getServiceDates: async ({
    refrenceNumber,
    processDefinitionKey,
    access_token,
  }) => {
    switch (mock) {
      case true:
        return {
          status: 200,
          data: [
            "2025-02-01T01:00:00",
            "2025-02-02T01:00:00",
            "2025-02-03T01:00:00",
            "2025-02-04T01:00:00",
            "2025-02-05T01:00:00",
            "2025-02-06T01:00:00",
            "2025-02-08T01:00:00",
          ],
        };
      default:
        return instance.post(`/Appointments/GetServiceDates`, {
          // serviceId,
          refrenceNumber,
          processDefinitionKey,
          access_token,
        });
    }
  },
  getServiceTimeSlots: async ({
    access_token,
    refrenceNumber,
    processDefinitionKey,
    appointmentDate,
  }) => {
    switch (mock) {
      case true:
        return {
          status: 200,
          data: [
            "2025-02-02T09:00:00",
            "2025-02-02T09:15:00",
            "2025-02-02T09:30:00",
            "2025-02-02T09:45:00",
            "2025-02-02T10:00:00",
            "2025-02-02T10:15:00",
            "2025-02-02T10:30:00",
            "2025-02-02T10:45:00",
            "2025-02-02T11:00:00",
            "2025-02-02T11:15:00",
            "2025-02-02T11:30:00",
            "2025-02-02T11:45:00",
            "2025-02-02T12:00:00",
            "2025-02-02T12:15:00",
            "2025-02-02T12:30:00",
            "2025-02-02T12:45:00",
            "2025-02-02T13:00:00",
            "2025-02-02T13:15:00",
            "2025-02-02T13:30:00",
            "2025-02-02T13:45:00",
            "2025-02-02T14:00:00",
            "2025-02-02T14:15:00",
            "2025-02-02T14:30:00",
            "2025-02-02T14:45:00",
            "2025-02-02T15:00:00",
            "2025-02-02T15:15:00",
            "2025-02-02T15:30:00",
            "2025-02-02T15:45:00",
            "2025-02-02T16:00:00",
            "2025-02-02T16:15:00",
            "2025-02-02T16:30:00",
            "2025-02-02T16:45:00",
            "2025-02-02T17:00:00",
            "2025-02-02T17:15:00",
            "2025-02-02T17:30:00",
            "2025-02-02T17:45:00",
            "2025-02-02T18:00:00",
            "2025-02-02T18:15:00",
            "2025-02-02T18:30:00",
            "2025-02-02T18:45:00",
          ],
        };
      default:
        return instance.post(`/Appointments/GetServiceTimeSlots`, {
          access_token,
          // serviceId,
          // appointmentDate,
          refrenceNumber,
          processDefinitionKey,
          appointmentDate,
        });
    }
  },
  postAppointment: async ({
    access_token,
    refrenceNumber,
    appointmentTime,
    processDefinitionKey,
  }) => {
    switch (mock) {
      case true:
        return { status: 200, data: true };
      default:
        return instance.post(`/Appointments/PostAppointment`, {
          access_token,
          refrenceNumber,
          processDefinitionKey,
          appointmentTime,
        });
    }
  },
  checkRequestPaid: async ({ refrenceNumber, hasCenterCode }) => {
    switch (mock) {
      case true:
        return { status: 200, data: true };
      default:
        return instance.get(`/Appointments/CheckRequestPaid`, {
          params: { refrenceNumber, hasCenterCode },
        });
    }
  },

  getValidSlotDates: async ({ refrenceNumber, deptCode }) => {
    switch (mock) {
      case true:
        return {
          status: 200,
          data: [
            "2025-02-01T01:00:00",
            "2025-02-02T01:00:00",
            "2025-02-03T01:00:00",
            "2025-02-04T01:00:00",
            "2025-02-05T01:00:00",
            "2025-02-06T01:00:00",
            "2025-02-08T01:00:00",
          ],
        };
      default:
        return instance.get(`/Appointments/GetValidSlotDates`, {
          params: {
            eDocNo: refrenceNumber,
            deptCode,
          },
        });
    }
  },
  getStartSlotsForDate: async ({ refrenceNumber, deptCode, selectedDate }) => {
    switch (mock) {
      case true:
        return {
          status: 200,
          data: [
            "2025-02-02T09:00:00",
            "2025-02-02T09:15:00",
            "2025-02-02T09:30:00",
            "2025-02-02T09:45:00",
            "2025-02-02T10:00:00",
            "2025-02-02T10:15:00",
          ],
        };
      default:
        return instance.get(`/Appointments/GetStartSlotsForDate`, {
          params: {
            eDocNo: refrenceNumber,
            deptCode,
            selectedDate,
          },
        });
    }
  },
  bookSelectedSlot: async ({
    refrenceNumber,
    deptCode,
    selectedDate,
    startSlot,
  }) => {
    switch (mock) {
      case true:
        return { status: 200, data: true };
      default:
        return instance.get(`/Appointments/BookSelectedSlot`, {
          params: {
            eDocNo: refrenceNumber,
            deptCode,
            selectedDate,
            startSlot,
          },
        });
    }
  },
  getLRD_LKP: async (data = {}) => {
    const { equalDis, notEqualDis } = data;
    switch (mock) {
      case true:
        return {
          status: 200,
          data: mockData.LRD_LKP,
        };
      default: {
        if (equalDis && notEqualDis) {
          return instance.get(
            `/Lookup/GetLRD_LKP?EqualDISTRECT_CODE=${equalDis}&NotEqualDISTRECT_CODE=${notEqualDis}`,
          );
        } else if (equalDis) {
          return instance.get(
            `/Lookup/GetLRD_LKP?EqualDISTRECT_CODE=${equalDis}`,
          );
        } else if (notEqualDis) {
          return instance.get(
            `/Lookup/GetLRD_LKP?NotEqualDISTRECT_CODE=${notEqualDis}`,
          );
        }
        return instance.get(`/Lookup/GetLRD_LKP`);
        return null;
      }
    }
  },
};
